import { ResponseMessage, useSendData } from 'sockets/sockets';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getAuthItem } from 'utils/httpRequestManager';
import { setResponse } from 'state/socketSlice';
import { setStats } from 'state/petitionSlice';

const useHandleResponse = () => {
	const dispatch = useDispatch();
	return useCallback(
		(m: ResponseMessage) => {
			if (!m) return;
			if (m.request === 'SAVE_TW2025') {
				dispatch(setStats(m.data as { num_sta: number; num_signed: number }));
			}
			dispatch(setResponse(m));
		},
		[dispatch]
	);
};

export const useGetDefaultNamespace = () => {
	const handler = useHandleResponse();
	return useCallback(
		(m: ResponseMessage) => {
			handler(m);
		},
		[handler]
	);
};

export const useSendRequest = () => {
	const send = useSendData();
	const token = getAuthItem()?.token ?? '';

	return useCallback(
		(request: string, params: object) => {
			send({
				token: token,
				namespace: 'default',
				request: request,
				params: params
			});
		},
		[send, token]
	);
};

export const useSaveTW = () => {
	const send = useSendData();

	return useCallback(() => {
		send({
			token: '',
			namespace: 'default',
			request: 'SAVE_TW2025',
			params: {}
		});
	}, [send]);
};
